import React from 'react';
import {
    Box,
    Pagination as MuiPagination,
    Typography,
    Stack,
} from '@mui/material';
import { useAppDispatch } from '../../store/hooks';
import { setPage } from '../../store/slices/filtersSlice';
import GearLoader from '../Common/GearLoader';

interface PaginationProps {
    totalItems: number;
    currentPage: number;
    lastPage: number;
    perPage: number;
    isLoading?: boolean;
}

const Pagination: React.FC<PaginationProps> = ({
    totalItems,
    currentPage,
    lastPage,
    perPage,
    isLoading = false
}) => {
    const dispatch = useAppDispatch();

    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        if (isLoading) return;

        dispatch(setPage(value.toString()));
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const from = (currentPage - 1) * perPage + 1;
    const to = Math.min(currentPage * perPage, totalItems);

    return (
        <Box sx={{ mt: 3, mb: 3 }}>
            <Stack spacing={2} alignItems="center">
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="body2" color="text.secondary">
                        Показано {from}-{to} из {totalItems} записей
                    </Typography>
                    {isLoading && <GearLoader size={16} />}
                </Box>

                <MuiPagination
                    count={lastPage}
                    page={currentPage}
                    onChange={handleChange}
                    disabled={isLoading}
                    color="primary"
                    size="large"
                    showFirstButton
                    showLastButton
                    sx={{
                        '& .MuiPaginationItem-root': {
                            borderRadius: 2,
                            '&.Mui-selected': {
                                backgroundColor: '#00A6E6',
                                '&:hover': {
                                    backgroundColor: '#0086C9',
                                },
                            },
                            '&.Mui-disabled': {
                                opacity: 0.5,
                            },
                        },
                    }}
                />
            </Stack>
        </Box>
    );
};

export default Pagination;
